// src/classes/class_1764437330265.js

const class_1764437330265 = 
  {
    id: 1764437330265,
    title: "Eggless Butter Cake Online Workshop",
    date: "",
    details: `✅ 2 different recipe for Eggless butter cake ( different substitutes) 
Join my Online Eggless Butter Cake Class and learn:
✅ Perfect soft & moist texture
✅ Pro tips for even rise and golden crust
✅ Storage, flavor variations & baking without cracks
✅ Variations ( recipes only) 
  Belgium Chocolate butter cake 
  Cranberry butter cake 
  Lemon butter cake 
Fees : 399 only`,
    time: "",
    price: "Rs. 399 /-",
    type: "online",
  }

export default class_1764437330265;
